import { render } from "./PlanningDatatableTDDoctorName.vue?vue&type=template&id=e19631dc"
import script from "./PlanningDatatableTDDoctorName.vue?vue&type=script&lang=js"
export * from "./PlanningDatatableTDDoctorName.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__